module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_torsby-467e6646e3ff01d5d16599ece4cb6b9f.png";